import { IAction } from "../../../models/Action";

export const actionTypes = {
  //set error
  SET_ERROR: "SET_ERROR",
};
export const setError = (payload: any): IAction => ({
  type: actionTypes.SET_ERROR,
  payload,
});
